import { z } from 'zod';
import { ACCIONES_AUDITORIA, ENTIDADES_AUDITABLES } from '../catalogos/auditoria.js';
import { esquemaId } from './comunes.js';
/**
 * Consulta de la bitacora.
 *
 * La bitacora es de solo lectura y de solo agregado: no hay esquema para crear
 * ni para corregir un asiento, a proposito. Un rastro que se puede editar no es
 * un rastro.
 */
export const esquemaListarBitacora = z.object({
    entidad: z.enum(ENTIDADES_AUDITABLES).optional(),
    entidadId: esquemaId.optional(),
    pacienteId: esquemaId.optional(),
    usuarioId: esquemaId.optional(),
    accion: z.enum(ACCIONES_AUDITORIA).optional(),
    /** Dia de calendario, inclusivo en los dos extremos. */
    desde: z
        .string()
        .trim()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use el formato AAAA-MM-DD')
        .optional(),
    hasta: z
        .string()
        .trim()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Use el formato AAAA-MM-DD')
        .optional(),
    pagina: z.coerce.number().int().min(1).default(1),
    porPagina: z.coerce.number().int().min(1).max(200).default(50),
});
/** Ancla externa a contrastar en `GET /auditoria/verificacion`. */
export const esquemaAnclaExterna = z.object({
    secuencia: z.coerce.number().int().min(1),
    hash: z
        .string()
        .trim()
        .regex(/^[0-9a-f]{64}$/, 'Hash SHA-256 en hexadecimal'),
});
//# sourceMappingURL=auditoria.js.map